// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { pick } from 'lodash'

import {
  EmployerRelatedMessagesList as RelatedMessagesList
} from '../../components'

import {
  EventContext
} from '../../context'


class EmployerRelatedMessages extends React.PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        employerId: PropTypes.string.isRequired,
        messageId: PropTypes.string.isRequired
      })
    }),
    employerId: PropTypes.string,
    messageId: PropTypes.string
  }

  state = {
    messageId: this.props.messageId || this.props.match.params.messageId,
    eventId: null,
    changeEventId: (eventId) => this.setState({ eventId })
  }

  goToMessageListingPage = () => (
    this.props.history.goBack()
  )

  changeMessageId = messageId => this.setState({ messageId })

  render() {
    const employerId = this.props.employerId || this.props.match.params.employerId
    const initialMessageId = this.props.messageId || this.props.match.params.messageId
    const messageId = this.state.messageId

    return (
      <div className='slds-size_1-of-1 slds-grid slds-wrap'>
        <EventContext.Provider value={pick(this.state, ['eventId', 'changeEventId'])}>
          <section className='slds-col slds-small-size_1-of-1 slds-medium-size_1-of-3 slds-align_absolute-center message-detail-container slds-scrollable_y'>
            <RelatedMessagesList
              title='Message history'
              employerIdentityId={employerId}
              initialMessageId={initialMessageId}
              currentMessageId={messageId}
              changeMessageId={this.changeMessageId}
              className='rounded-container slds-size_1-of-1 slds-m-around_small'
            />
          </section>
        </EventContext.Provider>
      </div>
    )
  }
}

export default withRouter(EmployerRelatedMessages)



// WEBPACK FOOTER //
// ./src/containers/messageplus/EmployerRelatedMessages.js